<!--
  本 HTML は複数コンポーネント（下記）で共有されているため、修正時は各画面への影響確認を十分にすること。
  ⇒OBD 全 DTC、OBD 個別診断 DTC、OBD 個別診断 パーマネント DTC

  なお、参照する data が増えると、各 js に定義しないと Warning が出てしまう問題を確認している。
  ⇒Property "xxx" was accessed during render but is not defined on instance.

  将来的に template 化を検討した方が良いかも。
-->
<div class="container-fluid ml-n2">
  <div>
    <div class="list-detail-top mt-2">
      <div>
        <b-button class="ml-2 mt-2" :disabled="isDisabledMemo || !measuredId" variant="primary" size="sm" v-on:click="openNoteModal">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button class="ml-2 mt-2" v-if="!isInvisibleChainButton" variant="primary" size="sm" v-on:click="switchChainDtc">
          {{ $t(getChainDtcButtonLabel()) }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measuredId" @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div>
        <b-button v-if="isVisibleReadinessCodeButton" class="ml-2 mt-2" :disabled="!measuredId" variant="primary" size="sm" v-on:click="openReadinessModal">
          {{ $t('individual.label_readiness_code') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measuredId" v-on:click="reGetDTC">
          {{ $t('message.button_vehicle_dtc_gain_again') }}
        </b-button>
        <b-button :disabled="!isEnableClearDtc || !measuredId" v-if="!isInvisibleClearDtcButton" class="ml-2 mt-2" variant="primary" size="sm" v-on:click="deleteDTC">
          {{ $t('message.button_vehicle_dtc_remove') }}
        </b-button>
      </div>
    </div>
  </div>

  <cstm-table useSort hasTabs rowSelect initSortDir="asc" :items="dtcListItems" :columns="dtcSystemTableColumns"
    class="mt-2 ml-2 list-diag-code" type="simple" @rowButtonClicked="clickFFD" currentSortkey="status" useStripeStyle>
    <template v-slot:rowButton="{ row }">
      <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
      <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
    </template>
  </cstm-table>

  <!-- FFD 一覧画面 -->
  <b-modal v-model="modalFfd" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- FFDタイトルの設定 -->
    <template v-slot:header>
      <div class="text-center w-100">
        {{ ffdTitle }}
      </div>
    </template>

    <ffd-modal v-if="modalFfd" :ffdTableProp="ffdSystemTable" :systemProp="selectedSystem" :ffdSystem="ffdSystem"
      :ffdDescription="ffdDescription" :isObd="isObd" :destinationAPI="destinationAPI" :projectId="projectId"
      :measureId="measuredId" @updateLoading="processing = $event" ref="ffd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport">
          Export DID Data
        </b-button>
      </template>
    </ffd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="modalFfd=false" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>
  <!-- レディネスコード -->
  <b-modal v-model="modalReadiness" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('individual.label_readiness_code') }}
      </div>
    </template>
    
    <template v-slot:default>
      <div class="container-fluid">
        <div class="row no-gutters">
          <div class="col-12 mt-3">
            <div class="d-flex w-100">
              <!-- DTC入力 -->
              <div class="w-40">
                <b-form-group>
                  <b-form-input
                    :placeholder="$t('individual.label_input_dtc_placeholder')"
                    v-model="readinessCodeInputDtc"
                    type="text"
                    size="sm"
                    :state="readinessCodeValidateDtc && !readinessCodeValidateDtc.valid"
                    autocomplete="off">
                  </b-form-input>
                  <b-form-invalid-feedback v-if="readinessCodeValidateDtc">{{ $t(readinessCodeValidateDtc.msg) }}</b-form-invalid-feedback>
                </b-form-group>
              </div>
              <!-- 追加ボタン -->
              <div class="ml-4">
                <b-button @click="onClickAddDtcReadinessCode" size="sm" variant="outline-primary">
                  {{ $t('individual.button_readiness_code_add') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 一覧 -->
        <div class="project-tbl-style" v-show="readinessCodeTable.length > 0">
          <div class="row width-max">
            <div class="col-12 mt-2 width-max">
              <cstm-table useSort hasTabs rowSelect useStripeStyle initSortDir="asc" :items="readinessCodeTable"
                :columns="readinessCodeTableColumns"
                class="mt-2 ml-2 list-scroll-readiness-code" type="simple" currentSortkey="status" @rowButtonClicked="deleteRowReadinessCode">
                <template v-slot:rowButton>
                  {{ $t('individual.label_readiness_code_delete') }}
                </template>
              </cstm-table>
            </div>
          </div>
        </div>
        <!-- 全削除ボタン -->
        <div class="mt-3 text-right">
          <b-button :disabled="readinessCodeTable.length == 0" @click="allDeleteReadinessCode" size="sm" variant="outline-primary" class="mx-2">
            {{ $t('individual.button_readiness_code_all_delete') }}
          </b-button>
          <b-button :disabled="readinessCodeTable.length == 0" class="ml-2" variant="primary" size="sm" @click="readinessCodeCsvExport">
            {{ $t('message.file_export') }}
          </b-button>
        </div>
      </div>
      <!-- 外側のprocessing-viewだと表示されない為、個別に設定 -->
      <processing-view :processing="processing"></processing-view>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="modalReadiness=false" class="mx-2">
          {{ $t("message.common_button_back") }}
        </b-button>
        <b-button :disabled="readinessCodeTable.length == 0" size="sm" variant="primary" @click="onClickDecisionReadinessCode" class="mx-2">
          {{ $t('individual.button_readiness_code_decision') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-Page v-if="modalMemo" ref="memo"
      :projectId="vehicleInfo.vehicle.project.id"
      :measureId="measuredId"
      :functionNameKey="functionNameKey"
      :obdFunctionLabelKey="obdFunctionLabelKey"
      @closeNoteModal="closeNoteModal"
      :modalLoading="isMemoDialogLoading" @update-loading="isMemoDialogLoading = $event"
      :destinationAPI="destinationAPI"
    />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">{{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo=false" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- DTC取得中のダイアログ -->
  <b-modal v-model="modalProgress" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_label_execution') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-Progress :value="progress" useResource :message="phaseMessage" />
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>